import util from '../util'

let controller = 'CobrancaServicos1'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetHistorico: function (codigoCobranca) {
    return util.Axios.Get(controller + '/Historico', codigoCobranca)
  },
  RealizarExtracao: function (search) {
    return util.Axios.GetAll(controller + '/Extracao', search)
  }
})
